module.exports = __webpack_public_path__ + "img/green-accent-2.ae130f7e.svg";